// extracted by mini-css-extract-plugin
export default {"root":"ActionsBarTimer_root__HOvDg","icon":"ActionsBarTimer_icon__Yo3Ht"};